export const DestinyDefinitionsWorkerMessages = {
	LOADED_DEFINITIONS: "LOADED_DEFINITIONS",
	UPDATING_MANIFEST: "UPDATING_MANIFEST"
} as const;